import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import Choices from "choices.js";
import 'choices.js/public/assets/styles/choices.css';
import {Fancybox} from "@fancyapps/ui";
import '@fancyapps/ui/dist/fancybox/fancybox.css';
import IMask from 'imask';
import './cart.js';

document.addEventListener("DOMContentLoaded", () => {
    // слайдеры
    if (document.querySelectorAll('.js--products-slider .swiper-slide').length > 0) {
        document.querySelectorAll('.js--products-slider').forEach(item => {
            let prevButton = item.closest('section').querySelector('.swiper-button-prev')
            let nextButton = item.closest('section').querySelector('.swiper-button-next')

            var slider = new Swiper(item, {
                modules: [Navigation],
                loop: true,
                spaceBetween: 25,
                slidesPerView: 2,
                navigation: {
                    nextEl: nextButton,
                    prevEl: prevButton,
                },
                pagination: {
                    el: '.swiper-pagination',
                },
                breakpoints: {
                    320: {
                        spaceBetween: 20,
                        slidesPerView: 1,
                    },
                    780: {
                        slidesPerView: 3,
                    },
                    1024: {
                        slidesPerView: 4,
                    },
                    1280: {
                        spaceBetween: 25,
                        slidesPerView: 5,
                    },
                },
            });
        })
    }

    if (document.querySelectorAll('.js--products-horisontal-slider .swiper-slide').length > 0) {
        document.querySelectorAll('.js--products-horisontal-slider').forEach(item => {
            let prevButton = item.closest('section').querySelector('.swiper-button-prev')
            let nextButton = item.closest('section').querySelector('.swiper-button-next')

            var slider = new Swiper(item, {
                loop: true,
                spaceBetween: 20,
                slidesPerView: 1,
                navigation: {
                    nextEl: nextButton,
                    prevEl: prevButton,
                },
                breakpoints: {
                    320: {
                        spaceBetween: 10,
                        slidesPerView: 2,
                    },
                    1024: {
                        spaceBetween: 20,
                        slidesPerView: 2,
                    },
                },
            });
        })
    }

    if (document.querySelectorAll('.js--media-slider .swiper-slide').length > 0) {
        document.querySelectorAll('.js--media-slider').forEach(item => {
            let prevButton = item.closest('section').querySelector('.swiper-button-prev')
            let nextButton = item.closest('section').querySelector('.swiper-button-next')

            var slider = new Swiper(item, {
                modules: [Navigation],
                loop: true,
                spaceBetween: 20,
                slidesPerView: 1,
                navigation: {
                    nextEl: nextButton,
                    prevEl: prevButton,
                },
                breakpoints: {
                    320: {
                        slidesPerView: 1,
                    },
                    780: {
                        slidesPerView: 2,
                    },
                    1024: {
                        slidesPerView: 3,
                    },
                },
            });
        })
    }

    if (document.querySelectorAll('.js--structure-slider .swiper-slide').length > 0) {
        document.querySelectorAll('.js--structure-slider').forEach(item => {
            // Ищем кнопки в родительском контейнере .structure__content
            let container = item.closest('.structure__content');
            
            console.log('Structure slider container:', container);
            
            let prevButton = container ? container.querySelector('.swiper-button-prev') : null;
            let nextButton = container ? container.querySelector('.swiper-button-next') : null;
            
            console.log('Structure slider prev button:', prevButton);
            console.log('Structure slider next button:', nextButton);

            // Конфигурация слайдера
            let swiperConfig = {
                modules: [Navigation],
                loop: true,
                spaceBetween: 20,
                breakpoints: {
                    320: {
                        slidesPerView: 2,
                    },
                    1024: {
                        slidesPerView: 3,
                    },
                },
            };

            // Добавляем навигацию только если кнопки существуют
            if (prevButton && nextButton) {
                console.log('Adding navigation to structure slider');
                swiperConfig.navigation = {
                    nextEl: nextButton,
                    prevEl: prevButton,
                };
            } else {
                console.log('Navigation buttons not found for structure slider');
            }

            var slider = new Swiper(item, swiperConfig);
            console.log('Structure slider initialized:', slider);
        })
    }

    if (document.querySelectorAll('.js--products-slider-cart .swiper-slide').length > 0) {
        document.querySelectorAll('.js--products-slider-cart').forEach(item => {
            if (item.closest('.header')) {
                var slider = new Swiper(item, {
                    loop: true,
                    spaceBetween: 20,
                    slidesPerView: 3,
                    breakpoints: {
                        320: {
                            slidesPerView: 2,
                        },
                        780: {
                            slidesPerView: 4,
                        },
                        1024: {
                            slidesPerView: 5,
                        },
                        1280: {
                            slidesPerView: 7,
                        },
                    },
                });
            } else {
                let prevButton = item.closest('section').querySelector('.swiper-button-prev')
                let nextButton = item.closest('section').querySelector('.swiper-button-next')

                var slider = new Swiper(item, {
                    modules: [Navigation],
                    loop: true,
                    spaceBetween: 20,
                    slidesPerView: 3,
                    navigation: {
                        nextEl: nextButton,
                        prevEl: prevButton,
                    },
                    breakpoints: {
                        320: {
                            slidesPerView: 2,
                        },
                        780: {
                            slidesPerView: 4,
                        },
                        1024: {
                            slidesPerView: 5,
                        },
                        1280: {
                            slidesPerView: 7,
                        },
                    },
                });
            }
        })
    }

    if (document.querySelectorAll('.js--mobile-categories .swiper-slide').length > 0 && window.innerWidth < 780) {
        document.querySelectorAll('.js--mobile-categories').forEach(item => {
            var slider = new Swiper(item, {
                spaceBetween: 0,
                slidesPerView: 1,
            });
        })
    }

    if (document.querySelectorAll('.js--mobile-subcategories .swiper-slide').length > 0 && window.innerWidth < 780) {
        document.querySelectorAll('.js--mobile-subcategories').forEach(item => {
            var slider = new Swiper(item, {
                spaceBetween: 20,
                slidesPerView: 2,
            });
        })
    }

    if (document.querySelectorAll('.js--item-photos .swiper-slide').length > 0) {
        document.querySelectorAll('.js--item-photos').forEach(item => {
            let prevButton = item.closest('section').querySelector('.swiper-button-prev')
            let nextButton = item.closest('section').querySelector('.swiper-button-next')
            let thumbs = item.closest('section').querySelector('.js--item-thumbs')

            var sliderThumbs = new Swiper(thumbs, {
                loop: true,
                spaceBetween: 0,
                slidesPerView: "auto",
                freeMode: true,
                watchSlidesProgress: true,
            });

            var slider = new Swiper(item, {
                modules: [Navigation],
                loop: true,
                navigation: {
                    nextEl: nextButton,
                    prevEl: prevButton,
                },
                thumbs: {
                    swiper: sliderThumbs,
                },
            });
        })
    }

    // селекты
    document.querySelectorAll('.js--select-style').forEach(item => {
        let select = new Choices(item, {
            allowHTML: true,
            allowHtmlUserInput: true,
            searchEnabled: false
        });

        item.addEventListener('choice', (event) => {
            if (event.detail.element.dataset.url) {
                window.location.href = event.detail.element.dataset.url;
            }
        })
    })

    Fancybox.bind("[data-fancybox]", {});

    document.querySelector('.js--toggle-description') && document.querySelector('.js--toggle-description').addEventListener('click', (e) => {
        let link = e.target;
        let cropText = document.querySelector('.description__crop-text');
        cropText.classList.toggle('visible');
        link.innerText = cropText.classList.contains('visible') ? link.dataset.hide : link.dataset.show;
    })

    // календарь (только для обычных календарей, не для корзины)
    // Календарь корзины инициализируется в cart-page.js через Vue
    const calendarElements = document.querySelectorAll('.calendar-inline:not(.range)');
    if (calendarElements.length > 0) {
        calendarElements.forEach(element => {
            flatpickr(element, {
                inline: true,
                "locale": "ru"
            });
        });
    }

    // маска телефон
    if (document.querySelectorAll('.js--input-phone').length) {
        document.querySelectorAll('.js--input-phone').forEach(input => {
            const mask = IMask(input, {mask: '+{7} (000) 000-00-00'});
        })
    }

    // карты
    // Every map takes its center from the markup: the view writes the coordinates of the
    // service setting into data-lat and data-lng, the placemark caption into data-caption.
    // No coordinates in the markup means no map container, so there is nothing to initialize.
    const mapElements = document.querySelectorAll('.map[data-lat][data-lng]');
    if (mapElements.length) {
        ymaps.ready(() => {
            mapElements.forEach((element) => {
                const lat = parseFloat(element.dataset.lat);
                const lng = parseFloat(element.dataset.lng);

                if (Number.isNaN(lat) || Number.isNaN(lng)) {
                    return;
                }

                const center = [lat, lng];
                const map = new ymaps.Map(element, {
                    center: center,
                    zoom: 14
                });

                const caption = element.dataset.caption;
                const placemark = caption
                    ? new ymaps.Placemark(center, {iconContent: caption}, {preset: 'islands#blueStretchyIcon'})
                    : new ymaps.Placemark(center);

                map.geoObjects.add(placemark);
            });
        });
    }

    // табы
    const tabs = document.querySelectorAll('.tabs__caption')
    if (tabs.length) {
        tabs.forEach((tab) => {
            tab.addEventListener('click', function (event) {
                let target = event.target
                if (!target.classList.contains('active')) {
                    let container = target.closest('.tabs');
                    let tabs = target.closest('.tabs__caption');
                    let tabsList = Array.from(tabs.children);
                    let index = tabsList.indexOf(target);
                    if (container.querySelector('li.active')) {
                        container.querySelector('li.active').classList.remove('active');
                    }
                    if (container.querySelector('.tabs__content.active')) {
                        container.querySelector('.tabs__content.active').classList.remove('active');
                    }
                    container.getElementsByClassName('tabs__content')[index].classList.add('active');
                    target.classList.add('active');
                }
            })
        });
    }

    // мобильное меню
    document.querySelector('.js--toggle-menu').addEventListener('click', () => {
        document.querySelector('.header').classList.toggle('open')
    })

    // поиск

    document.querySelector('.js--search').addEventListener('input', (e) => {
        let value = e.target.value;

        if(value.length  === 0) {
            hidesearchResult();
        } else {
            if(value.length > 3) {
                console.log('length')
                // запрос на получение результатов поиска
                updateSearchResult();
                setSearchResultParams();
            }
        }
    })

    document.querySelector('.js--toggle-search').addEventListener('click', (e) => {
        document.querySelector('.header .search').classList.toggle('visible')
        e.target.classList.toggle('close');
    })

    document.querySelector('.js--close-search').addEventListener('click', (e) => {
        hideSearchResult()
    })

    function setSearchResultParams() {
        let header = document.querySelector('.header')
        let searchContainer = document.querySelector('.header__result')
        searchContainer.style.top = header.offsetHeight + 'px';
        searchContainer.style.height = `calc(100vh - ${header.offsetHeight}px)`
        searchContainer.classList.remove('hidden');
        document.querySelector('body').classList.add('fixed')
    }
    function hideSearchResult () {
        document.querySelector('.header__result').classList.add('hidden');
        document.querySelector('body').classList.remove('fixed')
    }
    function  updateSearchResult() {
    }
})

// ============================================
// Обработчик кнопки "В корзину"
// ============================================
document.addEventListener('DOMContentLoaded', () => {
    const addToCartButtons = document.querySelectorAll('.js--add-to-cart');
    
    addToCartButtons.forEach(button => {
        button.addEventListener('click', function(e) {
            e.preventDefault();
            
            const itemId = this.dataset.itemId;
            
            if (itemId && window.CartModule) {
                window.CartModule.addToCart(itemId, 1);
                showNotification('Товар добавлен в корзину!', 'success');
            }
        });
    });
});

function showNotification(message, type = 'info') {
    const existingNotification = document.querySelector('.notification');
    if (existingNotification) {
        existingNotification.remove();
    }
    
    const notification = document.createElement('div');
    notification.className = `notification notification-${type}`;
    notification.textContent = message;
    
    document.body.appendChild(notification);
    
    setTimeout(() => {
        notification.classList.add('notification-hide');
        setTimeout(() => notification.remove(), 300);
    }, 3000);
}
